import { makeStyles } from '@material-ui/core/styles';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { fontFamilyEN as fontFamily, fontSize } from '../../../../styles/themes/vad/font';
import { translate } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  AdCalendarCarouselType2: {

    '& .slick-slider': {

      '& .slick-prev::before, & .slick-next::before': {
        content: "''",
      },

      '& .slick-arrow': {
        width: 'fit-content',
        height: 'fit-content',
        zIndex: '2',

        '&.slick-disabled': {
          opacity: '0',
        },

        '& button': {
          padding: pxToRem(16),
        },
      },

      '& .slick-prev': {
        left: pxToRem(66),
        right: 'unset',
      },

      '& .slick-next': {
        left: 'unset',
        right: pxToRem(66),
      },

      '& .slick-slide': {
        position: 'relative',
        padding: '0',
        ...theme.mixins.paddingLR(pxToRem(82.5), pxToRem(82.5)),

        '&:first-child .slideNumber-bg': {
          left: '-2rem', // Need same on rtl thats why no positionLR
          right: 'unset', // Need same on rtl thats why no positionLR
        },
      },
    },

    '& .slideNumber-bg': {
      margin: '0',
      padding: '0',
      position: 'absolute',
      top: '50%',
      left: '-5.3rem', // Need same on rtl thats why no positionLR
      right: 'unset', // Need same on rtl thats why no positionLR
      zIndex: '0',
      transform: 'translate(0, -50%)',
      fontSize: pxToRem(400),
      fontWeight: '700',
      lineHeight: pxToRem(400),
      color: '#00D8CC',
      letterSpacing: pxToRem(-33.6),
    },

    '& .ad-slide': {
      position: 'relative',
      zIndex: 3,

      '& .slideItemsWrapper': {
        position: 'relative',

        '& .slidePictureWrapper': {
          overflow: 'hidden',
          borderRadius: pxToRem(10),

          '& .slideElement': {
            transform: 'translateY(0)',

            '& picture': {
              minHeight: pxToRem(408),
              display: 'flex',

              '& img': {
                height: 'auto',
              },
            },

            '&:after': {
              content: '""',
              position: 'absolute',
              top: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%)',
              pointerEvents: 'none',
            },
          },
        },

        '& .slideInformation': {
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          justifyContent: 'space-between',
          padding: pxToRem(16) + ' ' + pxToRem(16) + ' ' + pxToRem(24),

          '& .slideInformationTop': {
            display: 'flex',
            flexDirection: theme.isDirectionRTL ? 'row-reverse' : 'row',

            '@media (max-width: 1023px)': {
              flexDirection: 'row',
            },

            '& .categoryLabel': {
              padding: pxToRem(4) + ' ' + pxToRem(8),
              borderRadius: pxToRem(3),
              backgroundColor: theme.mixins.White(),

              '& .categoryLabelText': {
                color: theme.palette.common.black,
                fontSize: pxToRem(12),
                fontWeight: '700',
                lineHeight: pxToRem(16),
                letterSpacing: pxToRem(0.5),
                textTransform: 'uppercase',
              },
            },

            '& .favouriteWrapper': {
              ...theme.mixins.marginLeft('auto'),
              width: pxToRem(24),
              height: pxToRem(24),

              '& .heartIcon': {
                display: 'flex',
                margin: 0,

                '& svg': {
                  width: pxToRem(24),
                  height: pxToRem(24),
                },
              },
            },
          },

          '& .slideInformationBottom': {
            display: 'flex',
            flexDirection: 'column',
            gap: pxToRem(12),
            textAlign: theme.isDirectionRTL ? 'right' : 'left',

            '& .timeText': {
              color: theme.mixins.White(),
              fontSize: pxToRem(12),
              fontWeight: '700',
              lineHeight: pxToRem(16),
              textTransform: 'uppercase',
            },

            '& .sliderTitle': {
              fontSize: pxToRem(22),
              fontWeight: '700',
              lineHeight: pxToRem(32),
              color: theme.mixins.White(),
              letterSpacing: '0px',
            },

            '& .slideInfoBorder': {
              borderRadius: pxToRem(10),
            },
          },
        },

      },
    },

    '@media (max-width: 1023px)': {
      overflowX: 'auto',
      overflowY: 'hidden',
      width: 'calc(100% + ' + pxToRem(48) + ')',
      ...theme.mixins.marginLeft(pxToRem(-24)),
      padding: '0 ' + pxToRem(32),

      '& .is-mobile': {
        display: 'flex',
        width: 'fit-content',
        paddingBottom: pxToRem(9),

        '& .slide-overlay-wrapper': {
          width: pxToRem(308),
          position: 'relative',
          marginLeft: pxToRem(156),

          '& .slideNumber-bg': {
            left: pxToRem(-152),
            right: 'unset',
          },

          '& .ad-slide': {
            zIndex: 3
          },

          '&:first-child': {
            marginLeft: theme.isDirectionRTL ? pxToRem(156) : pxToRem(64),
            marginRight: theme.isDirectionRTL ? pxToRem(-8) : 0,

            '& .slideNumber-bg': {
              left: pxToRem(-112),
              right: 'unset',
            },
          },

          '&:last-child': {
            ...theme.mixins.marginLR('0', pxToRem(-8)),
            marginRight: theme.isDirectionRTL ? 0 : pxToRem(16),
            marginLeft: theme.isDirectionRTL ? 0 : pxToRem(156),
          },
        },

      },
    },
  },
}));

export default useStyles;